import { useDndContext, useDroppable } from "@dnd-kit/core";
import { Box, BoxProps, useTheme } from "@mui/material";
import { MenuBuilderMenuItemType } from "../Meal/MenuBuilderMealSchema";
import { DAY_CELL_DROP_TYPE, isPanelMenuItemDragData } from "./dndTypes";

interface MenuBuilderDayCellDroppableProps extends BoxProps {
  id: string;
  disabled: boolean;
  addRowItem: (menuItem: MenuBuilderMenuItemType) => void;
  usedMenuItemIds: readonly string[];
}

export const MenuBuilderDayCellDroppable = ({
  id,
  disabled,
  addRowItem,
  usedMenuItemIds,
  sx,
  children,
  ...boxProps
}: MenuBuilderDayCellDroppableProps) => {
  const { active } = useDndContext();
  const {
    palette: { info },
  } = useTheme();
  const { setNodeRef, isOver } = useDroppable({
    id,
    disabled,
    data: {
      type: DAY_CELL_DROP_TYPE,
      addRowItem,
      usedMenuItemIds,
    },
  });

  const activeMenuItemId = isPanelMenuItemDragData(active?.data.current) ? active.data.current.menuItem.id : null;
  const isDuplicateDrop = activeMenuItemId !== null && usedMenuItemIds.includes(activeMenuItemId);
  const showValidDropHighlight = isOver && !isDuplicateDrop;

  return (
    <Box
      ref={setNodeRef}
      sx={[
        ...(Array.isArray(sx) ? sx : [sx]),
        showValidDropHighlight
          ? {
              boxShadow: `inset 0 0 0 1px ${info.main}`,
              backgroundColor: info.lighter,
            }
          : {},
      ]}
      {...boxProps}
    >
      {children}
    </Box>
  );
};
